import React, { memo, useEffect, useMemo, useRef, useState } from 'react';
import ReactTimeAgo from 'react-time-ago';
import cx from 'classnames';
import styles from './NotificationsPanel.module.scss';
import stylesNew from '../../screens/NewRegisterOnboard/NewRegister.module.scss';
import { icons } from '../../assets';
import {
  MODEL_TYPES,
  NOTIFICATION_MODEL_TYPE,
  ORG_JOIN_REQUEST_STATUS,
  SETTINGS_TAB,
} from '../../constants/constants';
import { Link } from 'react-router-dom';
import {
  ADMIN_MY_PRODUCTS_3DMODAL_EACH,
  ADMIN_MY_PRODUCTS_3DMODAL_EACH_V2,
  ADMIN_MY_PRODUCTS_ROOMS_DETAILS,
  ADMIN_MY_PRODUCTS_TEXTURE,
  ADMIN_MY_PRODUCTS_TEXTURE_V2,
  ADMIN_MY_PRODUCTS_TEXTURES_EACH_V2,
  ADMIN_SETTINGS,
  COLLECTION_ID,
  MY_FILES_SHARED_FILES_ROUTE,
  MY_PROJECTS_ROUTE,
  PRODUCT_WEB_EXPERIENCE_PUBLIC,
  PROPS_ROUTE,
  PROPS_ROUTE_V2,
  RENDER_DETAILS,
  RENDER_DETAILS_V2,
  REQUEST_DETAIL_ROUTE,
  REQUESTS_ROUTE_PDP,
  REQUESTS_ROUTE_PDP_DETAIL,
  SETTINGS_ROUTE,
  SHARED_FILES_ROUTE,
  SUPPORT_ROUTE,
  TEMPLATES_DETAILS,
  TEMPLATES_DETAILS_V2,
} from '../../constants/routePathConstants';
import { NotificationSharePropsDialog } from './NotificationSharePropsDialog';
import SkeletonLoaderUI, { SKELETON_LOADER_TYPE } from '../../skeletonLoaderUI/SkeletonLoaderUI';
import Button from '../../components/Button';
import { navigate } from '../../helpers/projectHelper';
import { handlePendingPayment } from '../../screens/subscriptionComponents/FailedSubscriptions';
import { getAppState } from '../../redux/store';
import { selectFailedSubscriptions } from '../../redux/slicers/subscriptionSlicer';
import { Elements, useStripe } from '@stripe/react-stripe-js';
import { useLoadStripe } from '../../hooks/useLoadStripe';
import { SHARED_OPTIONS_URL_PARAMS } from '../../helpers/configureHelper';
import ImagineLogo from '../../assets/images/ImagineLogo.png';
import DotsIcon from '../../components/icons/dots';
import MenuDropdown from '../MenuDropdown';
import {
  apiDeleteNotification,
  apiGetTeamMembersNew,
  assignProductPagePermissionToMember,
} from '../../helpers/api';
import { errorToast, successToast } from '../../helpers/toastHelper';
import { navigateToPlans } from '../../screens/subscriptionComponents/subscriptionHelper';
import InfoDialogUI from '../../components/InfoDialog/InfoDialogUI';
import BigButton from '../BigButton';
import { getRandomColor } from '../../helpers/jsHelper';
import { handleErrorMessageFromAPIFailer } from '../../helpers/axiosHelper';
import { useUserContext } from '../../contexts/UserContext';
import PaymentDoneIcon from '../../components/icons/PaymentDone';
import Loader from '../../components/Loader/Loader';

const { GreenTickIcon, RedCrossIcon } = icons;

export const NOTIFICATION_LINK_PLACEHOLDER_KEY = 'LabelLinkPlaceholder1';
export const NOTIFICATION_PLACEHOLDER_LABEL = `{${NOTIFICATION_LINK_PLACEHOLDER_KEY}}`;

function NameLink({ type, name, target_object_id, sub_type, data }) {
  const title = name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();

  if (!type && !name && !target_object_id) return null;
  if (NOTIFICATION_MODEL_TYPE.RenderStatus === type || NOTIFICATION_MODEL_TYPE.Preview === type) {
    let rname = title;
    let id = target_object_id;
    const render_data = data?.render_data;

    if (sub_type) {
      const index = sub_type.indexOf('_');
      const angleName = sub_type.slice(index + 1);
      rname = title + `_${angleName}`;
      id = target_object_id + `?cameraName=${angleName}`;
    }

    if (render_data && render_data?.is_automation) {
      id += '&automation=true';
    }

    return (
      <Link
        to={RENDER_DETAILS_V2.replace(':id', id)}
        target="_blank"
        onClick={(e) => e.stopPropagation()}>
        {rname}
      </Link>
    );
  } else if (NOTIFICATION_MODEL_TYPE.SharedFiles === type) {
    const shareLinkParam = `${MY_FILES_SHARED_FILES_ROUTE}?sharedOption=${SHARED_OPTIONS_URL_PARAMS.with_organisation}`;
    let shareLink = shareLinkParam;

    switch (sub_type) {
      case `${MODEL_TYPES.PRODUCT}`: // 1
        shareLink = PROPS_ROUTE_V2;
        break;

      case `${MODEL_TYPES.TEXTURE}`: // 2
        shareLink = ADMIN_MY_PRODUCTS_TEXTURE_V2;
        break;

      case `${MODEL_TYPES.ROOM}`: // 3
        shareLink = ADMIN_MY_PRODUCTS_ROOMS_DETAILS.replace(':id', target_object_id);
        break;

      case `${MODEL_TYPES.PROJECTS}`: // 4
        shareLink = MY_PROJECTS_ROUTE;
        break;

      case `${MODEL_TYPES.COLLECTION}`: // 5
        shareLink = COLLECTION_ID.replace(':id', target_object_id);
        break;

      case `${MODEL_TYPES.PROJECTRENDER}`: // 6
        shareLink = RENDER_DETAILS_V2.replace(':id', target_object_id);
        break;

      case `${MODEL_TYPES.THREESIXTY}`: // 7
        shareLink = shareLinkParam;
        break;

      case `${MODEL_TYPES.THREEDMODELS}`: // 8
        shareLink = ADMIN_MY_PRODUCTS_3DMODAL_EACH.replace(':id', target_object_id);
        break;

      case `${MODEL_TYPES.UPLOADS}`: // 9
        shareLink = RENDER_DETAILS_V2.replace(':id', target_object_id);
        break;

      case `${MODEL_TYPES.TEMPLATES}`: // 10
        shareLink = TEMPLATES_DETAILS_V2.replace(':id', target_object_id);
        break;

      case `${MODEL_TYPES.PREVIEWS}`: // 11
        shareLink = RENDER_DETAILS_V2.replace(':id', target_object_id);
        break;

      case `${MODEL_TYPES.WEBEXPERIENCE}`: // 12
      case 'webexperience':
        shareLink = PRODUCT_WEB_EXPERIENCE_PUBLIC.replace(':id', target_object_id);
        break;

      case `${MODEL_TYPES.TICKET}`: // 13
        shareLink = `${ADMIN_SETTINGS}?activeTab=${SETTINGS_TAB.MEMBERS}`;
        break;

      default:
        shareLink = shareLinkParam;
    }

    return (
      <Link to={shareLink} target="_blank" onClick={(e) => e.stopPropagation()}>
        {title}
      </Link>
    );
  } else if (NOTIFICATION_MODEL_TYPE.RequestStatusAndComments === type) {
    return (
      <Link
        to={`${ADMIN_SETTINGS}?activeTab=${SETTINGS_TAB.MEMBERS}`}
        target="_blank"
        onClick={(e) => e.stopPropagation()}>
        {title}
      </Link>
    );
  } else if (NOTIFICATION_MODEL_TYPE.LiveOnAppRender === type) {
    return (
      <Link
        to={TEMPLATES_DETAILS_V2.replace(':id', target_object_id)}
        target="_blank"
        onClick={(e) => e.stopPropagation()}>
        {title}
      </Link>
    );
  } else if (
    NOTIFICATION_MODEL_TYPE.RequestV2 === type &&
    data?.placeholder_data?.ticket_type === 'Product Page'
  ) {
    return (
      <Link
        to={`${REQUESTS_ROUTE_PDP}?id=${target_object_id}`}
        target="_blank"
        onClick={(e) => e.stopPropagation()}>
        {title}
      </Link>
    );
  } else if (NOTIFICATION_MODEL_TYPE.RequestV2 === type) {
    return (
      <Link
        to={REQUEST_DETAIL_ROUTE.replace(':id', '') + `?id=${target_object_id}`}
        target="_self"
        onClick={(e) => e.stopPropagation()}>
        {title}
      </Link>
    );
  } else if (
    [
      NOTIFICATION_MODEL_TYPE.Product,
      NOTIFICATION_MODEL_TYPE.Product360Viewer,
      NOTIFICATION_MODEL_TYPE.ProductARViewer,
    ].includes(type)
  ) {
    // NOTIFICATION_MODEL_TYPE.Product === type -> because we are not only creating 3d model for the product page
    // NOTIFICATION_MODEL_TYPE.ProductARViewer === type -> because we are only creating glbfile for the product page
    const isProductPage = [
      NOTIFICATION_MODEL_TYPE.ProductARViewer,
      NOTIFICATION_MODEL_TYPE.Product,
    ].includes(type);
    const URL =
      data?.is_product_data || isProductPage
        ? ADMIN_MY_PRODUCTS_3DMODAL_EACH_V2
        : ADMIN_MY_PRODUCTS_TEXTURES_EACH_V2;
    return (
      <Link
        to={URL.replace(':id', target_object_id)}
        target="_blank"
        onClick={(e) => e.stopPropagation()}>
        {title}
      </Link>
    );
  } else if (NOTIFICATION_MODEL_TYPE.JoinOrgRequest === type) {
    if (data?.join_request_data?.status === ORG_JOIN_REQUEST_STATUS.NEW) {
      return title;
    } else {
      return data?.join_request_data?.organization || title;
    }
  } else {
    return title;
  }
}

const navigateToPlansTab = (e) => {
  e.stopPropagation();
  navigateToPlans();
};

function GetActionButton({ data, callback }) {
  const stripe = useStripe();
  const { type, subscription } = data || {};

  const [loading, setLoading] = useState(false);
  const failedSubscriptions = selectFailedSubscriptions(getAppState())?.map((a) => a.id);

  if (type !== NOTIFICATION_MODEL_TYPE.Subscription) return null;

  const { details, plan_info } = subscription || {};
  const _handlePendingPayment = async (e) => {
    if (loading) return;
    setLoading(true);
    e?.stopPropagation();
    await handlePendingPayment({
      id: plan_info?.plan_id,
      stripe,
      pending_pi_client_secret_key: details?.pending_pi_client_secret_key,
    });
    callback?.();
    setLoading(false);
  };

  const buttonTitle = details?.is_view ? 'Explore your plan' : 'Pay now';
  const onClick = details?.is_view ? (e) => navigateToPlansTab(e) : (e) => _handlePendingPayment(e);

  if (!details?.is_view && !failedSubscriptions.includes(plan_info?.plan_id)) return null;

  return (
    <Button
      className={'mt-2 mb-2'}
      size={'lg'}
      color={'primary'}
      loading={loading}
      onClick={(e) => onClick(e)}>
      {buttonTitle}
    </Button>
  );
}

function GetAssignEditorActionBtn({ data }) {
  const [showModal, setShowModal] = useState(false);
  const permissionType = {
    VIEW: 'view',
    EDIT: 'edit',
  };

  if (
    data?.type !== NOTIFICATION_MODEL_TYPE.ProductPageShare &&
    !data?.product_page_data?.is_external_share
  )
    return null;
  if (!data?.target_object_id) return null;
  if (data?.data?.product_page_data?.permission_type === permissionType.VIEW) return null;

  const buttonTitle = 'Assign Editor';

  const onClick = () => {
    setShowModal(data);
  };

  const onClose = () => {
    setShowModal(false);
  };

  return (
    <>
      <Button className={'mt-2 mb-2'} size={'lg'} color={'primary'} onClick={(e) => onClick(e)}>
        {buttonTitle}
      </Button>
      <InfoDialogUI size="lg" show={showModal} onClose={onClose} closeable={false}>
        <AssignEditor data={data} onClose={onClose} />
      </InfoDialogUI>
    </>
  );
}

const NotificationsPanelCard = memo(
  ({ data, onClick, loadNotifications, refresh = false, setRefresh }) => {
    const {
      id,
      level,
      verb,
      timestamp,
      description,
      unread,
      is_muted,
      target_object_id,
      name,
      type,
      sub_type,
      data: notificationDetails,
    } = data;
    const [showRequestAccessDialog, setShowRequestAccessDialog] = useState(false);

    const { stripePromise } = useLoadStripe();

    const title = name !== null && name?.toLowerCase();
    const message = verb !== null && verb?.toLowerCase();
    let desc;
    if (description !== '') {
      if (description?.includes('\n')) {
        desc = description.split(/\r\n/g);
      } else {
        desc = description;
      }
    }

    const [loading, setLoading] = useState(false);
    const getClickedId = async (id) => {
      await onClick(id);
      setLoading(false);
    };

    if (loading)
      return <SkeletonLoaderUI type={SKELETON_LOADER_TYPE.NOTIFICATION} renderOne={true} />;

    const isAssetPermissionsRequest =
      type === NOTIFICATION_MODEL_TYPE.SharedFiles &&
      (notificationDetails?.type == 'shared_files' || data?.type === 'shared_files') &&
      Boolean(notificationDetails.request_access_data);

    const isGroupSharedNotification =
      type === NOTIFICATION_MODEL_TYPE.SharedFiles &&
      (notificationDetails?.type == 'shared_files' || data?.type === 'shared_files') &&
      notificationDetails?.shared_data?.is_group;

    const renderSharedDialog = isAssetPermissionsRequest || isGroupSharedNotification;

    const handleClick = () => {
      if (unread) {
        setLoading(true);
        getClickedId(id);
      }
    };

    const accessModal = () => {
      if (renderSharedDialog && !showRequestAccessDialog) {
        setShowRequestAccessDialog(true);
      }
    };

    const handleDeleteNotification = async () => {
      if (id) {
        const res = await apiDeleteNotification(id);
        if (res?.status) {
          setRefresh?.(!refresh);
          successToast(res?.message || 'Notification deleted successfully.');
        } else {
          errorToast(res?.message || 'Something went to wrong!');
        }
      }
    };

    const ActionMenu = [
      {
        label: 'Mark as read',
        value: null,
        onClick: handleClick,
        show: unread,
      },
      {
        label: 'Grant access',
        value: null,
        onClick: accessModal,
        show: renderSharedDialog,
      },
      {
        label: 'Delete notification',
        value: null,
        onClick: handleDeleteNotification,
        show: true,
      },
    ];

    const handleSelect = (method) => {
      method?.onClick && method?.onClick();
    };

    return (
      <div
        key={id}
        className={cx(
          styles.notificationCard,
          unread ? styles.unread : '',
          is_muted ? styles.muted : ''
        )}>
        <div className={cx(styles.notificationInfo)}>
          <img src={data?.profile_image || ImagineLogo} alt="log" />
          <div className="me-3">
            <h5>
              {/* {level === 'success' ? (
              <GreenTickIcon />
            ) : level === 'error' || level === 'failed' || level === 'disabled' ? (
              <RedCrossIcon />
            ) : (
              ''
            )} */}
              <Message
                message={message}
                initialMessage={verb}
                target_object_id={target_object_id}
                title={title}
                type={type}
                isAssetPermissionsRequest={isAssetPermissionsRequest}
                sub_type={sub_type}
                placeholder_data={notificationDetails?.placeholder_data}
                data={notificationDetails}
                failedPaymentLink={data?.data?.subscription?.hubspot_payment_link}
              />
            </h5>
            {desc?.length !== 0 && Array.isArray(desc) && (
              <p>
                &ldquo;
                {desc?.map((a, i) => (
                  <>
                    {a}
                    {i !== desc?.length - 1 && <br />}
                  </>
                ))}
                &rdquo;
              </p>
            )}
            {typeof desc === 'string' && <p>&ldquo;{description}&rdquo;</p>}
            <Elements stripe={stripePromise}>
              <GetActionButton data={data?.data} callback={loadNotifications} />
            </Elements>
            <GetAssignEditorActionBtn data={data} />
            {timestamp && Date.parse(timestamp) ? (
              <p>
                <ReactTimeAgo date={Date.parse(timestamp)} />
              </p>
            ) : null}
          </div>
          <div className={styles.notificationImg}>
            {data?.image && <img src={data?.image} alt="thumbnai" />}
            <MenuDropdown
              defaultPrevent
              btnClassName="py-0 pe-0"
              icon={<DotsIcon />}
              menu={ActionMenu.filter(({ show }) => show && show === true)}
              handleSelect={handleSelect}
            />
          </div>
        </div>

        {renderSharedDialog && showRequestAccessDialog && (
          <NotificationSharePropsDialog
            show={showRequestAccessDialog}
            onClose={() => {
              setShowRequestAccessDialog(false);
            }}
            details={notificationDetails}
            type={
              isGroupSharedNotification
                ? NotificationSharePropsDialog.TYPE.SHARED_DATA
                : NotificationSharePropsDialog.TYPE.REQUEST
            }
            onSuccess={() => setShowRequestAccessDialog(false)}
          />
        )}
      </div>
    );
  }
);

const Message = ({
  message,
  initialMessage,
  type,
  title,
  target_object_id,
  isAssetPermissionsRequest,
  sub_type,
  placeholder_data,
  data,
  failedPaymentLink,
}) => {
  // if (isAssetPermissionsRequest) {
  //   return message;
  // }

  if (failedPaymentLink) {
    message = (
      <span>
        Please{' '}
        <span
          style={{ color: 'var(--primary-color)', cursor: 'pointer' }}
          onClick={() => window.open(failedPaymentLink, '_blank')}>
          reconfirm
        </span>{' '}
        your payment.
      </span>
    );
    return message;
  }

  if (placeholder_data) {
    if (!initialMessage) return null;

    let updatedMessage = initialMessage;
    Object.entries(placeholder_data).forEach(([key, value]) => {
      if (key !== NOTIFICATION_LINK_PLACEHOLDER_KEY) {
        updatedMessage = updatedMessage.replace(`{${key}}`, value);
      }
    });

    if (placeholder_data[NOTIFICATION_LINK_PLACEHOLDER_KEY]) {
      const reg = new RegExp(`(${NOTIFICATION_PLACEHOLDER_LABEL})`);
      updatedMessage = updatedMessage.split(reg);

      updatedMessage = updatedMessage.map((m, i) => {
        if (m !== NOTIFICATION_PLACEHOLDER_LABEL) return m;

        return (
          <NameLink
            key={i}
            type={type}
            name={placeholder_data[NOTIFICATION_LINK_PLACEHOLDER_KEY]}
            target_object_id={target_object_id}
            sub_type={sub_type}
            data={data}
          />
        );
      });
    }

    return updatedMessage;
  }

  const NOTIFICATION_PLACEHOLDER = NOTIFICATION_PLACEHOLDER_LABEL.toLowerCase();

  /* TODO: code below needs refactoring! it's too complicated to read :( */
  return message?.includes(NOTIFICATION_PLACEHOLDER) ? (
    type && title && target_object_id ? (
      <>
        {message.indexOf(NOTIFICATION_PLACEHOLDER) !== 0
          ? message.slice(0, 1).toUpperCase() +
            message.slice(1, message.indexOf(NOTIFICATION_PLACEHOLDER))
          : message.slice(0, message.indexOf(NOTIFICATION_PLACEHOLDER))}
        <NameLink
          type={type}
          name={title}
          target_object_id={target_object_id}
          sub_type={sub_type}
          data={data}
        />
        {message.slice(message.indexOf(NOTIFICATION_PLACEHOLDER) + NOTIFICATION_PLACEHOLDER.length)}
      </>
    ) : (
      message.replace(NOTIFICATION_PLACEHOLDER, title).slice(0, 1).toUpperCase() +
      message.replace(NOTIFICATION_PLACEHOLDER, title).slice(1).toLowerCase()
    )
  ) : (
    message.replace(NOTIFICATION_PLACEHOLDER, title).slice(0, 1).toUpperCase() +
      message.replace(NOTIFICATION_PLACEHOLDER, title).slice(1).toLowerCase()
  );
};

export default NotificationsPanelCard;

export const AssignEditor = (props) => {
  const { currentUser } = useUserContext();
  const [submitLoader, setSubmitLoader] = useState(false);
  const [loader, setLoader] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [memberList, setMemberList] = useState([]);
  const [nextLink, setNextLink] = useState(null);
  const [search, setSearch] = useState('');
  const loaderRef = useRef(null); // Ref for the loading div
  const { data, onClose, assignEditorProductList, assignEditorMultipleAPI, assignLoader } =
    props || {};

  useEffect(() => {
    handleGetMemberList();
  }, []);

  // useEffect(() => {
  //   const delayDebounce = setTimeout(() => {
  //      handleGetMemberList(!search, search);
  //   }, 400);
  //   return () => clearTimeout(delayDebounce);
  // }, [search]);

  useEffect(() => {
    // IntersectionObserver to load more data when the loaderRef is visible
    const observer = new IntersectionObserver(
      (entries) => {
        const target = entries[0];
        if (target.isIntersecting && nextLink) {
          handleGetMemberList();
        }
      },
      { threshold: 1.0 }
    );

    if (loaderRef.current) {
      observer.observe(loaderRef.current);
    }

    return () => {
      if (loaderRef.current) {
        observer.unobserve(loaderRef.current);
      }
    };
  }, [nextLink]);

  const handleGetMemberList = async (isReset, searchVal) => {
    const url =
      nextLink && !searchVal
        ? nextLink?.split('?')[1]
        : `per_page=20&page=1&sort=name&search=${search}`;
    setLoader(true);
    const res = await apiGetTeamMembersNew(`${url}`);
    setLoader(false);
    if (res?.results?.length || searchVal) {
      const owner = res?.results.filter((a) => a.role_data.is_owner && a?.is_editor_access);
      const members = res?.results.filter((a) => !a.role_data.is_owner && a?.is_editor_access);
      if (searchVal || isReset) {
        setMemberList([...addBgColor([...owner, ...members] || [])]);
      } else {
        setMemberList((prevList) => [...prevList, ...addBgColor([...owner, ...members] || [])]); // Merge new results with current list
      }
      setNextLink(res.next_link);
    } else {
      setMemberList([]);
      setNextLink(null);
    }
  };

  const addBgColor = (results) => {
    const data = results?.map((item) => {
      return {
        ...item,
        bgColor: getRandomColor(),
      };
    });
    return data;
  };

  const handleSelectedOrg = (selectedId) => {
    if (!selectedId) return;
    const cloneOrgList = memberList.slice();
    const findIndex = cloneOrgList.findIndex(({ id }) => +id === +selectedId);
    if (~findIndex) {
      cloneOrgList[findIndex]['selected'] = cloneOrgList[findIndex].selected ? false : true;
      cloneOrgList?.map((item, index) => {
        if (findIndex !== index) {
          cloneOrgList[index]['selected'] = false;
        }
      });
    }
    setMemberList(cloneOrgList);
  };

  const handleAssignEditor = async () => {
    const selectedMember = memberList.filter(({ selected }) => selected)?.[0];
    if (!selectedMember || !data?.target_object_id) return;
    setSubmitLoader(true);
    try {
      // Make API calls sequentially
      const formData = new FormData();
      formData.append('shared_to_member', selectedMember.id);
      const res = await assignProductPagePermissionToMember({
        id: data?.target_object_id,
        data: formData,
      });
      const status = res?.status || res?.data?.status;
      if (!status) {
        handleErrorMessageFromAPIFailer(res);
        setSubmitLoader(false);
        return; // Stop if any request fails
      } else {
        setShowSuccessModal(selectedMember);
      }
      // resetStateValue();
    } catch (error) {
      handleErrorMessageFromAPIFailer(error);
    } finally {
      setSubmitLoader(false);
    }
  };

  const enableJoinBtn = memberList?.some(({ selected }) => selected);

  return (
    <div className={stylesNew.chooseYourOrg}>
      {showSuccessModal ? (
        <>
          <div className={styles.successContainer}>
            <p>
              <PaymentDoneIcon />
            </p>
            <h2>Editor access shared successfully!</h2>
            <div className={styles.subDescription}>
              <p>
                {showSuccessModal?.user?.email || showSuccessModal?.user?.name} has been
                successfully assigned access to view and edit the{' '}
                <strong>{data?.name || data?.data?.product_page_data?.name || ''}</strong>.
              </p>
            </div>
            <div className={styles.actionButtonContainer}>
              <BigButton
                className={`keep-text text-white ${styles.okayBtn}`}
                onClick={() => onClose?.()}
                disabled={false}
                buttonTitle={'Okay'}
              />
            </div>
          </div>
        </>
      ) : (
        <>
          <h2>Assign editor</h2>
          <div className={stylesNew.subDescription}>
            <p>This file has been shared with your organization on edit access.</p>
            <p>Select any editor who will have edit access on this file.</p>
          </div>
          <div className={stylesNew.orgListContainer}>
            {loader && !memberList?.length && (
              <div>
                <span className="mt-2">
                  <Loader loading size={26} thickness={2} />
                </span>
              </div>
            )}
            {!memberList?.length && !loader && (
              <div>
                <span>No data available.</span>
              </div>
            )}
            <ul className={stylesNew.orgList}>
              {memberList?.map((memberInfo, index) => {
                return (
                  <>
                    <li key={memberInfo?.id}>
                      <input
                        type="checkbox"
                        checked={memberInfo?.selected}
                        name="inverted1"
                        onChange={() => handleSelectedOrg?.(memberInfo?.id)}
                      />
                      <span
                        className={stylesNew.avatar}
                        style={{ backgroundColor: memberInfo?.bgColor || '#EFAB5D' }}>
                        {memberInfo?.user?.name?.trim()?.charAt(0) || 'O'}
                      </span>
                      <span>
                        {memberInfo?.user?.name || memberInfo?.user?.email}{' '}
                        {currentUser.user.email === memberInfo?.user?.email ? '(You)' : ''}
                      </span>
                    </li>
                    {index + 1 === memberList?.length && nextLink && (
                      <li>
                        <div ref={loaderRef}>Loading more...</div>
                      </li>
                    )}
                  </>
                );
              })}
            </ul>
          </div>
          <div className={stylesNew.actionButtonContainerNotification}>
            <BigButton
              className={`lf-btn-1 keep-text white-text ${stylesNew.continueBtn}`}
              onClick={() =>
                assignEditorProductList
                  ? assignEditorMultipleAPI?.(memberList.filter(({ selected }) => selected)?.[0])
                  : handleAssignEditor()
              }
              disabled={!enableJoinBtn}
              isLoading={submitLoader || assignLoader}
              buttonTitle="Continue"
            />
          </div>
        </>
      )}
    </div>
  );
};
